export default __webpack_public_path__ + "static/media/greatseasons-logo.3ceb5083.jpg";